import './NoResults.scss';

export type NoResultsProps = {
	show: boolean;
	keyWord: string;
	handleResetFilter: () => Promise<void>;
};

const NoResults: React.FC<NoResultsProps> = ({
	show,
	keyWord,
	handleResetFilter,
}) => {
	const handleKeyDown = (event: React.KeyboardEvent<HTMLAnchorElement>) => {
		if (event.key != 'Enter') {
			return;
		}
		handleResetFilter();
	};

	return (
		<>
			<div
				className="col-lg-8 col-md-10 col-12 no-result-container"
				hidden={!show}
			>
				<div className="no-result-header">No results found</div>
				<div className="no-result-body">
					We couldn&apos;t find any results based on your search criteria.
				</div>
				<div className="no-result-options">
					What are my options?
					<ul className="no-result-list">
						<li hidden={keyWord === ''}>
							<i className="fa fa-circle iconField dot-icon"></i>Please check if
							&quot;
							<div className="bold">{keyWord}</div>
							&quot; has any typo
						</li>
						<li>
							<i className="fa fa-circle iconField dot-icon"></i>
							Change your filters
						</li>
						<li>
							<i className="fa fa-circle iconField dot-icon"></i>
							<a
								className="link"
								tabIndex={0}
								onKeyDown={handleKeyDown}
								onClick={handleResetFilter}
								role="link"
								data-final-url
							>
								Reset the results
							</a>
						</li>
					</ul>
				</div>
			</div>
		</>
	);
};

export default NoResults;
